import { AdSlot } from "react-dfp";

import styles from "../Advertisement.module.scss";

export const HomepageMobileTopAd: React.FC = () => {
  const isClientSide = typeof window !== "undefined";
  const isMobile = isClientSide && window.innerWidth <= 1024;

  return (
    <div className={styles.homeMobileTop}>
      {isMobile ? (
        <AdSlot
          adUnit={`newoncev3_homepage1mobile`}
          sizes={[[300, 400], [300, 250], [1, 1], "fluid"]}
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default HomepageMobileTopAd;
